import React, {Component}  from 'react';
import {
  Panel,
  Modal,
  Button,
  ProgressBar,
  FormGroup,
  ControlLabel,
  FormControl,
  Grid,
  Row,
  Col,
  Form,
  InputGroup
}                           from 'react-bootstrap'
import axios                from "axios";
import FileSaver            from "file-saver";
import {
  ToastContainer,
  toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";
import moment               from "moment";
import socketIOClient     from "socket.io-client";
import DateTime           from "react-datetime";
import                         "style/react-datetime.css";

import { MEMBER_TOKEN }     from "actions/const";

import {
  IS_NULL,
  IS_VALID,
  GENERATE_RANDOM
}                           from "utils";

import saveTrail            from '../../utils/saveTrail';

import CrudComponent        from './../zynappse-crud'
import var1                 from '../schema/MemberDetail.js'
import FormContainer        from "./FormContainer";

const SERVER_URL = window.__APP_CONFIG__.SERVER_URL
const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class Home extends Component {
  constructor (props) {
    super(props);

    this.refreshTableReference;
    this.exportComponentRef = React.createRef();

    this.state = {
      showModalExport: false
    };

    this.refreshTable = this.refreshTable.bind(this);
    this.customExport = this.customExport.bind(this);
    this.uploadCSVFile = this.uploadCSVFile.bind(this);
    this.renderModalButton = this.renderModalButton.bind(this);
    this.checkForExistingMember = this.checkForExistingMember.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  refreshTable () {
    if (!IS_NULL(this.refreshTableReference) && typeof this.refreshTableReference === "function") {
      this.refreshTableReference();
    }
  }

  customExport (
    {
      className,
      queryJson
    },
    cb
  ) {
    this.setState({
      showModalExport: true
    }, () => {
      cb();
    });
    // axios({
    //   method: "post",
    //   url: WEB_PATH + "/MemberDetail/export",
    //   data: {
    //     queryJson: JSON.stringify(queryJson)
    //   },
    //   responseType: "arraybuffer"
    // })
    // .then((res) => {
    //   let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
    //   FileSaver.saveAs(blob, `MemberDetail Report ${moment().format("MMM-DD-YYYY")}.xlsx`);

    //   cb();
    // })
    // .catch((err) => {
    //   console.log("error", err);
    //   cb();
    // });
  }

  uploadCSVFile () {
    let {
      MemberToken,
      actions
    } = this.props;

    let {
      csvFile
    } = MemberToken;

    if (!IS_VALID(csvFile)) {
      toast.error("CSV File is required.");
    } else {
      actions.setValue(
        MEMBER_TOKEN,
        {
          isLoadingAction: true
        }
      );

      let fd = new FormData();

      fd.append("csvFile", csvFile);

      axios.post(
        WEB_PATH + "/MemberDetail/upload",
        fd
      )
      .then((res) => {
        console.log("response: ", res);

        actions.setValue(
          MEMBER_TOKEN,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();
      })
      .catch((err) => {
        console.log("error: ", err);

        actions.setValue(
          MEMBER_TOKEN,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();
      });
    }
  }

  renderModalButton () {
    let {
      MemberToken,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      isLoadingAction,
      memberId_isChecking,
      memberId_isExisting
    } = MemberToken;

    let buttons = [],
        buttonAction = (
          name = "CREATE",
          loading = isLoadingAction,
          callback = this.saveData
        ) => (
          <Button
              bsStyle="primary"
              disabled={loading}
              onClick={() => callback()}
          >
              {name}
          </Button>
        ),
        buttonClose = (
          <Button
            disabled={isLoadingAction || memberId_isChecking}
            onClick={() => {
              if (!isLoadingAction || memberId_isChecking) {
                actions.setValue(
                  MEMBER_TOKEN,
                  {
                    showModal: false
                  }
                );
              }
            }}
            >
            CANCEL
          </Button>
        );


    switch (formType.toUpperCase()) {
      case "MASS_UPLOAD":
        buttons.push(buttonAction(
          'UPLOAD',
          isLoadingAction,
          this.uploadCSVFile
        ));
        buttons.push(buttonClose);
        break;
      case "CREATE":
        buttons.push(buttonAction(
          'CREATE',
          isLoadingAction || memberId_isChecking,
          this.saveData
        ));
        buttons.push(buttonClose);
        break;
      case "UPDATE":
        buttons.push(buttonAction(
          'UPDATE',
          isLoadingAction || memberId_isChecking,
          this.saveData
        ));
        buttons.push(buttonClose);
        break;
      default:

    }
    return buttons;
  }

  checkForExistingMember (value) {
    const {
      MemberToken,
      actions
    } = this.props;

    const {
      formType,
      formId,
  
      memberId_isExisting
    } = MemberToken;

    let isUpdateForm = (IS_VALID(formType) && formType.toUpperCase() === "UPDATE") && IS_VALID(formId);

    const stateToUpdate = {
      memberId_isChecking: true
    };

    if (memberId_isExisting) {
      stateToUpdate.memberId_isExisting = false;
    }

    actions.setValue(
      MEMBER_TOKEN,
      stateToUpdate
    );
    
    const memberDetailQuery = new Parse.Query('MemberDetail');

    memberDetailQuery
    .equalTo('memberId', value);

    if (isUpdateForm) {
      memberDetailQuery.notEqualTo("objectId", formId);
    }

    memberDetailQuery.first()
    .then((memberDetail) => {
      const stateToUpdate = {
        memberId_isChecking: false
      };

      const showPopup = () => {
        stateToUpdate.memberId_isExisting = true;
      };

      if (memberDetail) {
        showPopup();
      }

      actions.setValue(
        MEMBER_TOKEN,
        stateToUpdate
      );
    })
    .catch((err) => {
      console.log("checkForExistingMember error: ", err);
        
      actions.setValue(
        MEMBER_TOKEN,
        {
          memberId_isChecking: false
        }
      );
    });
  }

  saveData () {
    const {
      MemberToken,
      actions
    } = this.props;

    const {
      selectedData,
      formType,
      formId,

      form_memberId,
      form_cardType,

      memberId_isExisting
    } = MemberToken;

    let isUpdateForm = (IS_VALID(formType) && formType.toUpperCase() === "UPDATE") && IS_VALID(formId);

    if (
      !IS_VALID(form_memberId) ||
      !IS_VALID(form_memberId.trim())
    ) {
      toast.error("Member ID is required.");
    } else if (
      memberId_isExisting
    ) {
      toast.error("Member ID already exists.");
    } else {
      actions.setValue(
        MEMBER_TOKEN,
        {
          isLoadingAction: true
        }
      );

      const memberDetailQuery = new Parse.Query('MemberDetail');

      memberDetailQuery
      .equalTo('memberId', form_memberId);

      if (isUpdateForm) {
        memberDetailQuery.notEqualTo("objectId", formId);
      }

      memberDetailQuery.first()
      .then((memberDetail) => {
        if (memberDetail) {
          return Promise.reject('EXIST');
        }

        return;
      })
      .then(() => {
        let memberDetail = new Parse.Object('MemberDetail');

        if (
          isUpdateForm &&
          selectedData
        ) {
          memberDetail = selectedData;
        }

        const auditTrail = {};

        if (
          !memberDetail.get('memberId') ||
          memberDetail.get('memberId') !== form_memberId
        ) {
          memberDetail.set('memberId', form_memberId.trim());

          auditTrail.memberId = form_memberId.trim();
        }

        if (
          !memberDetail.get('cardType') ||
          memberDetail.get('cardType') !== form_cardType
        ) {
          memberDetail.set('cardType', form_cardType.trim());

          auditTrail.cardType = form_cardType.trim();
        } else if (memberDetail.get('cardType')) {
          memberDetail.unset('cardType');
        }

        return Promise.all([
          memberDetail.save(),
          auditTrail
        ]);
      })
      .then(([ memberDetail, auditTrail ]) => {
        auditTrail.id = memberDetail.id;

        actions.setValue(
          MEMBER_TOKEN,
          {
            isLoadingAction: false,
            showModal: false
          }
        );

        this.refreshTable();

        saveTrail(
            formType.toUpperCase(),
            auditTrail
        );
      })
      .catch((err) => {
        if (err === 'EXIST') {
          toast.error("Member ID already exists.");
        }

        actions.setValue(
          MEMBER_TOKEN,
          {
            isLoadingAction: false
          }
        );
      })
    }
}

  render() {
    let {
      MemberToken,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      formType,
      formTitle
    } = MemberToken;

    let {
			access
		} = accessjson;

    var vipMember = [
      { method: "descending", column: "createdAt" }
    ];

    if (Parse.User.current()) {
      if (typeof Parse.User.current().get('userType') !== 'undefined') {
        if (Parse.User.current().get('userType').toUpperCase() === 'VIP HOST') {
          vipMember.push({ method: 'equalTo', column: 'vipHost', value: Parse.User.current() });
        }
      }
    }

    let crudProps = {
      schema: var1,
      refreshTable: (refreshTable) => {this.refreshTableReference = refreshTable;},
      moduleQuery: vipMember,
      access: access,
      saveTrail: saveTrail,
      customExport: this.customExport,
      additionalButtons: [
        {
          style: {},
          disabledState: false,
          func: ({ filter, query }) => {
            actions.setValue(
              MEMBER_TOKEN,
              {
                showModal: true,
                formType: "MASS_UPLOAD",
                formTitle: "MASS UPLOAD MEMBER"
              }
            )
          },
          loaderState: false,
          label: "MASS UPLOAD"
        }
      ],
      customCreate: () => {
        actions.setValue(
          MEMBER_TOKEN,
          {
            showModal: true,
            formType: "CREATE",
            formTitle: "CREATE MEMBER"
          }
        );
      },
      customUpdate: (obj) => {
        const stateToUpdate = {
          showModal: true,
          formType: "UPDATE",
          formTitle: "UPDATE MEMBER",
          formId: obj.id,
          selectedData: obj
        };

        if (IS_VALID(obj.get("memberId"))) {
          stateToUpdate.form_memberId = obj.get("memberId");
        }

        if (IS_VALID(obj.get("cardType"))) {
          stateToUpdate.form_cardType = obj.get("cardType");
        }

        actions.setValue(
          MEMBER_TOKEN,
          stateToUpdate
        );
      }
    };

    let formContainerProps = {
      ...this.props,
      checkForExistingMember: this.checkForExistingMember
    };

    return (
			<div>
        <Panel>
  				<Panel.Heading style={{
  					backgroundColor: '#D1282F',
  					color: 'white'
  				}}>
  					<h4>{var1.classNameLabel.toUpperCase()}</h4>
  				</Panel.Heading>
  				<Panel.Body>
  					<CrudComponent {...crudProps}/>
  				</Panel.Body>
  			</Panel>
        <Modal
          bsSize={formType === 'MASS_UPLOAD' ? "sm" : null}
          show={showModal}
          onHide={() => {
            if (!isLoadingAction) {
              actions.setValue(
                MEMBER_TOKEN,
                {
                  showModal: false
                }
              );
            }
          }}
          >
          <Modal.Header closeButton>
            <Modal.Title>{(IS_VALID(formTitle) ? formTitle : formType).toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            {this.renderModalButton()}
          </Modal.Footer>
        </Modal>
        <Modal
            bsSize={null}
            backdrop="static"
            show={this.state.showModalExport}
            onHide={() => {
                if (
                  this.exportComponentRef.current &&
                  this.exportComponentRef.current.isLoading()
                ) {
                 return;   
                }
                
                this.setState({
                  showModalExport: false
                });
            }}
          >
             <Modal.Header closeButton>
                  <Modal.Title>EXPORT MEMBER</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ExportComponent
                  ref={this.exportComponentRef}
                  closeModal={() => {
                      this.setState({ showModalExport: false });
                  }}
                />
              </Modal.Body>
          </Modal>
        <ToastContainer />
      </div>
		);
  }
}

class ExportComponent extends Component {
  constructor (props) {
    super(props);
  
    this.state = {
      password: "",
      startDate: "",
      endDate: "",

      isExportStarting: false,
      isExporting: false,
      isExportSuccess: false,
      isExportError: false,
      exportPercentage: 0,
      fileConfig: {
          filename: "",
          blob: ""
      },
      errorMessage: ""
    };

    this.exportData = this.exportData.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
    this.isLoading = this.isLoading.bind(this);
  }

  exportData () {
    let {
      password,
      startDate,
      endDate
    } = this.state;

    if (
      IS_VALID(startDate) &&
      !moment(startDate).isValid()
    ) {
      toast.error("Please select a valid Start Date.");
    } else if (
      IS_VALID(endDate) &&
      !moment(endDate).isValid()
    ) {
      toast.error("Please select a valid End Date.");
    }
    // else if (
    //   !IS_VALID(password) ||
    //   !IS_VALID(password.trim())
    // ) {
    //     toast.error("Excel File Password is required.");
    // } 
    else {
      this.setState({
        isExportStarting: true
      });

      let params = {
        // password: password.trim()
      };

      if (
        IS_VALID(startDate)
      ) {
        params.startDate = moment(startDate).startOf("day").format();
      }
      
      if (
        IS_VALID(endDate)
      ) {
        params.endDate = moment(endDate).endOf("day").format();
      }

      axios.post(
        WEB_PATH + "/MemberDetail/export",
        params,
        {
            timeout: 30000
        }
      )
      .then((res) => {
        let {
          fileName,
          socketNspId
        } = res.data;

        this.setState({
          isExportStarting: false,
          isExporting: true
        });

        let io = socketIOClient(
          WEB_PATH,
          {
              transports: ["websocket"],
              path: "/socket.io",
              query: {
                  nspId: socketNspId
              },
              secure: true
          }
        );

        let listenerName = "export-member-detail-socket";

        io.on(
          listenerName,
          (data) => {
              let {
                  status,
                  progress,
                  fileName,
                  message
              } = data;
              if (status === "PROGRESS") {
                  this.setState({
                      exportPercentage: progress
                  });
              } else if (status === "DONE") {
                  io.off(listenerName);
                  io.close();
                  
                  axios.get(
                    WEB_PATH + "/MemberDetail/download/" + fileName,
                     {
                          responseType: "arraybuffer"
                      }
                  )
                  .then((res2) => {
                      let blob = new Blob([res2.data], { type: "application/vnd.ms-excel" }),
                          filename = `Member ${moment().format("MMM DD YYYY hh:mm A")}.xlsx`;
      
                      this.setState({
                          isExporting: false,
                          isExportSuccess: true,
                          exportPercentage: 100,
                          fileConfig: {
                          filename: filename,
                          blob: blob
                          }
                      });
      
                      FileSaver.saveAs(blob, filename);
                  })
                  .catch((err) => {
                      let errorMessage = err.message;
      
                      if (
                          err.response &&
                          err.response.data &&
                          ("TextDecoder" in window)
                      ) {
                          let enc = new TextDecoder("utf-8");
                          let arr = new Uint8Array(err.response.data);
                          
                          let data = JSON.parse(enc.decode(arr)) || {};
      
                          if (
                              data.error &&
                              data.error.message
                          ) {
                              errorMessage = data.error.message;
                          }
                      }
                      
                      this.setState({
                          isExporting: false,
                          isExportError: true,
                          errorMessage
                      });
                  });
              } else if (status === "ERROR") {
                  io.off(listenerName);
                  io.close();
                  
                  this.setState({
                      isExporting: false,
                      isExportError: true,
                      errorMessage: message
                  });
              }
          }
        );
      })
      .catch((err) => {
        let errorMessage = err.message;

        if (
            err.response &&
            err.response.data &&
            typeof err.response.data === "string"
        ) {
            errorMessage = err.response.data;
        }

        this.setState({
            isExportStarting: false,
            isExportError: true,
            errorMessage
        });
      });
    }
  }

  downloadFile () {
    let {
        fileConfig
    } = this.state;

    let {
        filename,
        blob
    } = fileConfig

    if (IS_VALID(filename) && IS_VALID(blob)) {
        FileSaver.saveAs(blob, filename);
    }
  }

  isLoading () {
    let {
        isExportStarting,
        isExporting
    } = this.state;

    return isExportStarting || isExporting;
  }

  render () {
    let {
      password,
      startDate,
      endDate,

      isExportStarting,
      isExporting,
      isExportSuccess,
      isExportError,
      exportPercentage,
      errorMessage
    } = this.state;

    let {
        closeModal
    } = this.props;

    return (
      <div>
        {
          !isExporting &&
          !isExportSuccess &&
          !isExportError ? (
            [
              <p>Exporting of Member may take some time depending on the number of records.</p>,
              <Form>
                <Row>
                  <Col
                      md={8}
                      mdOffset={2}
                  >
                  <FormGroup>
                    <ControlLabel>Created At</ControlLabel>
                    <InputGroup>
                      <DateTime
                          dateFormat="MMM DD, YYYY"
                          timeFormat={false}
                          value={startDate}
                          onChange={(date) => {
                              this.setState({
                                  startDate: date
                              });
                          }}
                          inputProps={{
                              placeholder: "Start Date",
                              style: {
                                  position: "initial",
                                  borderRadius: "4px 0 0 4px"
                              }
                          }}
                      />
                      <InputGroup.Addon>TO</InputGroup.Addon>
                      <DateTime
                          dateFormat="MMM DD, YYYY"
                          timeFormat={false}
                          value={endDate}
                          onChange={(date) => {
                              this.setState({
                                  endDate: date
                              });
                          }}
                          inputProps={{
                              placeholder: "End Date",
                              style: {
                                  position: "initial",
                                  borderRadius: "0 4px 4px 0"
                              }
                          }}
                      />
                  </InputGroup>
                  </FormGroup>
                  </Col>
                </Row>
              </Form>,
              // <br/>,
              // <p>Note: The export files will be password protected with the recommended password below. </p>,
              // <Form inline>
              //  <FormGroup>
              //     <ControlLabel>Recommended Password<span style={{ color: "red" }}>*</span>:&nbsp;</ControlLabel>
              //     <FormControl
              //       disabled={isExportStarting}
              //       value={password}
              //       onChange={(e) => {
              //         if (!isExportStarting) {
              //             this.setState({ password: e.target.value });
              //         }
              //       }}
              //     />
              //   </FormGroup>
              // </Form>,
              <br/>,
              <br/>,
              <div style={{ textAlign: "center" }}>
                <Button  
                  className="btn-primary"
                  disabled={isExportStarting}
                  onClick={() => {
                    this.exportData()
                  }}>
                  {isExportStarting ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }} /> </span> : ""}  EXPORT
                  </Button>
              </div>
            ]
          ) : (
            ""
          )
        }
        {
          isExporting ? (
            [
              <p>This may take some time depending on the number of records.</p>,
              <ProgressBar
                active
                striped
                bsStyle="success"
                now={exportPercentage}
                label={`${exportPercentage}%`}
              />
            ]
          ) : isExportSuccess || isExportError ? (
            isExportSuccess ? (
              <div style={{ textAlign: "center" }}>
                  <Button
                      bsStyle="success"
                      content="DOWNLOAD FILE"
                      onClick={this.downloadFile}
                  >
                      DOWNLOAD FILE
                  </Button>
              </div>
            ) : (
              [
                <h3 style={{ textAlign: "center", color: "red" }}>Something went wrong.</h3>,
                <h4 style={{ textAlign: "center"}}>{errorMessage}</h4>,
                <div style={{ textAlign: "center" }}>
                  <Button
                    bsStyle="primary"
                    onClick={() => {
                      closeModal();
                    }}>
                    CLOSE
                  </Button>
                </div>
              ]
            )
          ) : (
            ""
          )
        }
      </div>
    );
  }
  
  componentDidMount () {
    this.setState({
        password: GENERATE_RANDOM(10, "string")
    });
  }
}


import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

function mapStateToProps(state) {
	var {
    MemberToken,
		accessjson
	} = state;

	const props = {
    MemberToken,
		accessjson
	};
	return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: generics.setValue
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./components/Home/index.js